<script>
import {deleteTierPricing, saveTierPricing} from "@/api/price";

  export default {
    props:{
      selectArea:{},
      tierList:{},
      tirelist:[]
    },
    data(){
      return {
        column: [
          { label: "Tier", prop: "name",minWidth:'260'},
          { label: "Pricing", prop: "price" ,minWidth:'260'},
        ],
        tierPage:1,
        tierTotal:0,
        tierTitle:'Create a tire pricing',
        selectItem:'',
        tierCreatDialog:false,
        tierCreateForm:{
          tier_name:"",
          price:'',
          color:'',
        },
        tierRulesForm:{
          tier_name: [
            { required: true, message: 'Please select a tier', trigger: 'change' }
          ],
          price: [
            { required: true, message: 'Please input a pricing', trigger: ['blur', 'change'] },
            { min: 0, max: 10000, message: 'Price must be between 0 and 10000', trigger: ['blur', 'change'] } // 假设价格范围限制
          ],
          color: [
            { required: true, message: 'Please select a color', trigger: 'change' }
          ]
        },
        selectedColor: '',
        colorOptions: [
          { value: '#e4e4e4', label: '灰色' },
          { value: '#ff69b4', label: '粉红色' },
          { value: '#ba55d3', label: '紫色' },
          { value: '#87ceeb', label: '天蓝色' },
          { value: '#00ffff', label: '青色' },
          { value: '#7fff00', label: '绿色' },
          { value: '#ffa500', label: '橙色' },
          { value: '#ff0000', label: '红色' },
        ],
        tierDeleteDialog:false,
        deleteSelect:'',
        deleteOption:[],
      }
    },
    created() {
    },
    methods:{
      resetForm(){
        this.tierCreateForm = {
          name:'',
          price:'',
          color:'',
        }
        this.$nextTick(()=>{
          this.$refs.perTasksRef.clearValidate()
        })
      },

      confirmAreaCreate(){
        this.tierCreateForm.ma_code = this.selectArea
        this.$refs.perTasksRef.validate((valid) => {
          if (valid) {
            if (this.tierTitle == 'Create a tire pricing'){
              this.tierCreateForm.id = ''
            }else{
              this.tierCreateForm.id = this.selectItem.id
            }
            saveTierPricing(this.tierCreateForm).then(res=>{
              if (res.code == 200){
                this.$message({
                  type: 'success',
                  message:res.msg
                })
                this.tierCreatDialog = false
                this.$emit('updateList')
              }else {
                this.$message({
                  type: 'error',
                  message:res.msg
                })
              }
            })
          }else{
            this.$message({
              type: 'warning',
              message:'Some information missing'
            })
          }
        })

      },
      tietDeleteHandler(row){
        this.selectItem = row
        this.deleteOption = []
        this.tierList.forEach(item=>{
          if (row.id != item.id){
            this.deleteOption.push(item)
          }
        })
        this.deleteOption.push({
          name:'Unset',
          id:'',
          price:''
        })
        this.deleteOption.forEach((item)=>{
          if  (item.id == ''){
            item.label = item.name
          }else{
            item.label = item.name + ' ' +'- ' + ' ' +'$' +item.price
          }
        })
        this.tierDeleteDialog = true
      },
      tierEditHandler(row){
        this.selectItem = row
        this.tierCreateForm = row
        this.tierCreateForm.tier_name = row.name
        this.tierTitle='Edit a tier pricing';
        this.tierCreatDialog = true
      },
      tierfirmDelete(){
        console.log(this.selectItem,'selectItem')
        deleteTierPricing({
          id:this.selectItem.id,
          replace_tier_id:this.deleteSelect
        }).then(res=>{
          if (res.code == 200){
            this.$message({
              type: 'success',
              message:res.msg
            })
            this.tierDeleteDialog = false
            this.$emit('updateList')
          }else {
            this.$message({
              type:"error",
              message:res.msg
            })
          }
        })
      },
      handleInput(value) {
        // 过滤非数字字符
        this.tierCreateForm.price  = value.replace(/\D/g, '');
      },
    }
  }
</script>

<template>
  <div>
    <el-table
      class="mt-4"
      v-if="tierList.length"
      :data="tierList"
    >
      <el-table-column
        v-for="(item, index) in column"
        :label="item.label"
        :prop="item.prop"
        :key="index"
        :width="item.minWidth"
      >
      </el-table-column>
      <el-table-column
        label="Color"
      >
        <template  slot-scope="scope">
            <div class="w-20 h-8 rounded-2xl"
              :style="{
                backgroundColor: scope.row.color
              }"
            ></div>
        </template>
      </el-table-column>
      <el-table-column
        label="Action"
        width="100"
      >
        <template slot-scope="scope">
          <div class="action">
            <span @click="tietDeleteHandler(scope.row)" class="cursor-pointer">
                <img src="../../assets/zipCode/delete@2x.png" class="w-4 mr-4" alt="">
              </span>
            <span @click="tierEditHandler(scope.row)" class="cursor-pointer">
                <img src="../../assets/zipCode/edit@2x.png" class="w-4 mr-4" alt="">
              </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <table-empty v-else></table-empty>
    <el-dialog
      :close-on-click-modal="false"
      style="padding-top: 0"
      :title="tierTitle"
      :visible.sync="tierCreatDialog"
      @close="resetForm"
      top="5vh"
      width="35%">
      <div>
        <el-form :model="tierCreateForm" label-position="top" :rules="tierRulesForm" status-icon ref="perTasksRef" :show-message="false">
          <el-form-item label="Tier" required prop="tier_name">
            <el-select v-model="tierCreateForm.tier_name" placeholder="Select">
              <el-option
                :disabled="item.disabled"
                v-for="item in tirelist"
                :key="item.tier_name"
                :label="item.tier_name"
                :value="item.tier_name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label=" Pricing" required prop="price">
            <el-input v-model="tierCreateForm.price" @input="handleInput"  placeholder=" Input a tier pricing"></el-input>
          </el-form-item>
          <el-form-item label="Color"  prop="color">
            <div class="color_select">
              <el-select v-model="tierCreateForm.color" placeholder="Select">
                <el-option v-for="option in colorOptions" :key="option.value" :value="option.value">
                  <div class="w-6 h-6 rounded-xl" :style="{ backgroundColor: option.value }"></div>
                  <template #default>
                    <div class="flex items-center">
                      <div class="w-6 h-6 rounded-xl mr-2" :style="{ backgroundColor: option.value }"></div>
                      {{ option.value }}
                    </div>
                  </template>
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <div style="float:left;" v-if="tierTitle === 'Edit a tier pricing'">
            <el-button type="primary" round class="btn-custom-red" style="width: 80px; padding: 0" @click="tietDeleteHandler(selectItem)">Delete</el-button>
        </div>
          <el-button type="success" round  @click="tierCreatDialog = false" >Cancel</el-button>
          <el-button plain class="changeFocus" @click="confirmAreaCreate">Submit</el-button>
      </span>
    </el-dialog>
<!--    删除-->
    <el-dialog
      :close-on-click-modal="false"
      style="padding-top: 0"
      title="Delete this tier pricing"
      :visible.sync="tierDeleteDialog"
      width="35%">
      <div class="addInner" style="margin-top: 24px">
        <div class="mb-2">
          Will you delete {{selectItem.name}}? How do you want to switch the current settings with {{selectItem.name}} pricing?
        </div>
        <div>
          <el-select v-model="deleteSelect" placeholder="Select">
            <el-option
              v-for="item in deleteOption"
              :key="item.id"
              :label="item.label"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button plain style="width: 80px" class="changeFocus"  @click="tierDeleteDialog = false">No</el-button>
        <el-button type="success" round style="width: 80px;padding: 0"  @click="tierfirmDelete">Yes</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style scoped lang="less">
.color_select{
  .el-select{
    width: 100px !important;
  }
}
/deep/.el-select-dropdown__item{
  text-align: left;
}
</style>
